export default {
  type: 'object',
  properties: {
    uid: {
      title: 'UID dokumentu z MDOK',
      type: 'number',
      fieldRequired: true
    },

    documentValues: {
      type: 'object',
      properties: {
        numberCode: {
          type: 'string',
          title: 'Wartość systemowa numeru dokumentu'
        },

        number: {
          type: 'string',
          title: 'Numer dokumentu'
        },

        dateCode: {
          type: 'string',
          title: 'Wartość systemowa daty dokumentu'
        },

        date: {
          type: 'string',
          format: 'date',
          title: 'Data dokumentu'
        }
      }
    }
  }
};
